import { render } from "./bottom.vue?vue&type=template&id=aa19a862&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=aa19a862&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa19a862"]])

export default __exports__